import cls from 'classnames';
import { memo } from 'react';

import { IndeterminateProgress } from '../IndeterminateProgress';

import { ILoaderProps } from './types';
import useStyles from './loaderStyles';

function Loader({ isSingle, children, className }: ILoaderProps) {
  const classes = useStyles();
  let type: 'thin' | 'thick' = 'thin';
  let textClassName = classes.textNormal;

  if (isSingle) {
    type = 'thick';
    textClassName = classes.textLarge;
  }

  return (
    <div className={cls(classes.root, className)}>
      <div className={textClassName}>{children}</div>
      <IndeterminateProgress type={type} />
    </div>
  );
}

export default memo(Loader);
